import { atom } from "jotai";
import type { OptionValueDto } from "@models/option";

export const optionValuesAtom = atom<OptionValueDto[]>([]);

export const isFetchingOptionValuesAtom = atom<boolean>(false);

export const isProcessingOptionValuesAtom = atom<boolean>(false);
